// Rails 8 / jsbundling-rails entry point — replaces app/javascript/packs/application.js
// Built by `yarn build` via esbuild → app/assets/builds/application.js, served by Propshaft.

import Rails from "@rails/ujs"
import { start as startActiveStorage } from "@rails/activestorage"
import "./channels"

import "./packs/lib/wow.min.js"
import "./packs/lib/bootstrap.min.js"
import "./packs/lib/slick.js"
import "./select2-init.js"
import "./packs/custom.js"
import "./packs/front/customer.js"

Rails.start()
startActiveStorage()
